var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"main"}},[(_vm.isSuccess)?_c('div',[_c('img',{attrs:{"src":"images/car_wash/true.png","alt":""}}),_c('p',[_vm._v("恭喜您领券成功")])]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }